<template lang="pug">
  .background__container(:class="{ 'has-sale-info-bar': showSaleInfoBar }")
    template(v-if="!isMobile")
      video.background__media(
        ref="bgVideo"
        autoplay
        loop
        muted
        playsinline
        poster="@/assets/images/mint-poster.jpg"
      )
        source(
          src="@/assets/videos/mint.mp4"
        )
    template(v-else)
      img.background__media.image(src="@/assets/images/mint.jpg")
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'MintBackground',
  props: {
    isMobile: { type: Boolean, default: false },
    showSaleInfoBar: { type: Boolean, default: false },
  },
  computed: {
    ...mapGetters('accounts', ['isUserConnected']),
  },
  beforeDestroy() {
    if (!this.isMobile) {
      this.$refs.bgVideo.removeEventListener('canplaythrough', this.videoIsReady);
    }
  },
  mounted() {
    if (!this.isMobile) {
      this.$refs.bgVideo.addEventListener('canplaythrough', this.videoIsReady);
    }

    if (this.isMobile || this.$refs.bgVideo.readyState > 3) {
      this.videoIsReady();
    }
  },
  methods: {
    videoIsReady() {
      this.$emit('video-ready');
    },
  },
};
</script>

<style lang="scss">
.background__media {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: bottom;
  z-index: -1;
  transition: height 0.5s cubic-bezier(0, 0, 0, 1);

  .has-sale-info-bar & {
    height: calc(100% - 80px);
  }
}

.is-vertical {
  .has-sale-info-bar {
    .background__media {
      height: 100%;
    }
  }
}
</style>
